// Tom's operational estimate, 3 Nov 2026. Does not determine VAT eligibility
// or post accounting entries. Purchase records and legacy metrics stay intact.
const valid=n=>typeof n==='number'&&Number.isFinite(n)&&n>=0;
const round=n=>Math.round((n+Number.EPSILON)*100)/100;
const fees=hammer=>hammer*(0.0475+0.0242)+0.25;
function treatment(cost={},acquisition={}){
 if(['imported','recorded_total','domestic'].includes(cost.importTreatment))return cost.importTreatment;
 if(cost.costKind==='supplier_purchase_reference'||/^(cardrush|hareruya):/i.test(acquisition.externalID||'')||cost.sources?.some(s=>['cardrush','hareruya'].includes(String(s.supplier||s.source||'').toLowerCase())))return 'imported';
 if(cost.costKind==='recorded_slab_purchase')return 'recorded_total';
 if(cost.sourceLabel==='Buylist')return 'domestic';
 return 'unknown';
}
function operatingEstimate({hammerGBP,rawGBP,gradingGBP,totalGBP,importTreatment='unknown',actualFeesGBP=null}={}){
 const h=valid(hammerGBP)&&hammerGBP>0?hammerGBP:null;
 const components=valid(rawGBP)&&valid(gradingGBP);
 const imported=importTreatment==='imported',recorded=importTreatment==='recorded_total';
 const importVAT=imported&&components?rawGBP*0.2:importTreatment==='domestic'||recorded?0:null;
 const purchase=imported&&components?rawGBP*1.2:importTreatment==='domestic'&&components?rawGBP:recorded&&valid(totalGBP)?totalGBP:null;
 const total=purchase!==null?(recorded?purchase:purchase+gradingGBP):null;
 const fee=h===null?null:valid(actualFeesGBP)?actualFeesGBP:fees(h);
 const vat=h!==null&&purchase!==null?Math.max(0,h-purchase)/6:null;
 const profit=h!==null&&total!==null&&vat!==null&&fee!==null?h-total-vat-fee:null;
 return {version:'tom-operating-v1',importTreatment,importVATGBP:importVAT===null?null:round(importVAT),landedPurchaseGBP:purchase===null?null:round(purchase),landedCostInclGradingGBP:total===null?null:round(total),feesGBP:fee===null?null:round(fee),feesEstimated:!valid(actualFeesGBP),marginVATGBP:vat===null?null:round(vat),profitGBP:profit===null?null:round(profit),marginPercent:profit===null?null:round(profit/h*100)};
}
function forCost(cost={},acquisition={}){return operatingEstimate({...cost.estimate,importTreatment:treatment(cost,acquisition)});}
function rawCeiling({hammerGBP,gradingGBP,targetMargin=0.25}={}){
 if(!valid(hammerGBP)||!valid(gradingGBP)||!valid(targetMargin)||targetMargin>=1)return null;
 // For Tom's imported-raw policy: H - 1.2R - G - fees - (H-1.2R)/6.
 return round(Math.max(0,hammerGBP*(5/6-targetMargin)-gradingGBP-fees(hammerGBP)));
}
module.exports={operatingEstimate,forCost,treatment,rawCeiling};
